module.exports = __webpack_public_path__ + "static/media/4594.22fa8a20.jpg";